<script>
import { iButton, iTextInput, showToast } from '@inscribe/signal';
import { doRedirect } from '@/utils/auth';

export default {
  components: {
    iButton,
    iTextInput,
  },
  data() {
    return {
      loading: false,
      intervalId: undefined,
      otpCode: undefined,
    };
  },
  computed: {
    isRequestActive() {
      return !!this.intervalId;
    },
  },
  mounted() {
    this.requestOnetouch();
  },
  beforeUnmount() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    },
    startChecking() {
      this.intervalId = setInterval(this.checkTwoFaStatus, 2000);
    },
    requestOnetouch() {
      if (this.$route.query.type === 'ONETOUCH') {
        if (this.$route.query.isEnabling) {
          this.$store.dispatch('requestOneTouch').then(() => {
            this.startChecking();
          });
        } else {
          this.startChecking();
        }
      }
    },
    verifyOtp() {
      this.loading = true;
      this.$store
        .dispatch('verifyOtp', this.otpCode)
        .then(() => {
          this.loading = false;
          const { redirectUrl } = this.$route.query;
          doRedirect(redirectUrl);
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            showToast({
              title: 'Incorrect Two Factor Auth Code',
              text: error?.response?.data?.message || 'Please try again',
              isError: true,
            });
          }
        });
    },
    checkTwoFaStatus() {
      this.$store
        .dispatch('checkTwoFaStatus')
        .then((response) => {
          this.loading = false;
          const onetouchResponse = response.data.data;
          if (onetouchResponse === 'approved') {
            this.clearInterval();
            const { redirectUrl } = this.$route.query;
            doRedirect(redirectUrl);
          } else if (onetouchResponse !== 'pending') {
            this.clearInterval();
          }
        })
        .catch((error) => {
          this.loading = false;
          showToast({
            title: 'Error logging in',
            text: error?.response?.data?.message || 'Please try again',
            isError: true,
          });
        });
    },
  },
};
</script>

<template>
  <div
    class="two-fa-screen auth-screen d-flex flex-column align-items-center justify-content-center i-gap-10"
  >
    <div class="title d-flex flex-column align-items-center i-gap-1">
      <div class="i-text-heading-3 i-text-neutral-120">Two-Factor Auth</div>
      <div class="i-text-body-1 i-text-neutral-110">
        Sign in to your account
      </div>
    </div>

    <div class="d-flex w-100 justify-content-center">
      <img src="../../img/security.svg" width="300px" class="i-mb-3 mx-auto" />
    </div>

    <div
      v-if="$route.query.type === 'ONETOUCH'"
      class="form d-flex flex-column i-gap-10"
      title="Verify with Authy App"
    >
      We have sent you a request to authenticate this login to your two factor
      authentication device, please check it and approve the request to login.

      <i-button
        text="Request Again"
        type="primary"
        subtype="strong"
        size="lg"
        :disabled="isRequestActive"
        :loading="isRequestActive"
        @button-click="requestOnetouch"
      ></i-button>
    </div>

    <div v-if="$route.query.type === 'OTP'" title="Verify With OTP Code">
      <div class="form d-flex flex-column i-gap-10">
        <!-- input -->
        <i-text-input
          :model-value="otpCode"
          label="Two Factor Auth Code"
          placeholder="xxx-xxx"
          name="otp_code"
          type="text"
          :has-error="!isRequestActive"
          :show-hint-text="false"
          hint-text="A two factor auth code is required"
          @update:model-value="otpCode = $event"
        ></i-text-input>

        <i-button
          id="verifyOtp"
          text="Verify Code"
          type="primary"
          subtype="strong"
          size="lg"
          :loading="loading"
          @button-click="verifyOtp"
        ></i-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.two-fa-screen {
  .form {
    max-width: 400px;
    text-align: center;
  }
}
</style>
